module.exports = __webpack_public_path__ + "static/img/default_network.bfff551.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/defaultTip/img/default_network.jpg
// module id = GucA
// module chunks = 27